import { bootStrapAppAsync, OnAuthFail } from '@chr/common-ui-bootstrapper';
import { getConfiguration } from '@chr/common-web-ui-configuration';
import { authClientOptions } from './app/common/auth/auth-client-options';
import { ChrDecodedJwt } from '@chr/common-web-ui-authentication/authClientTypes';
import { datadogRum } from '@datadog/browser-rum';
import { init as fsInit } from '@fullstory/browser';

const authError: OnAuthFail = async (e) => {
  const { handleAuthError } = await import(
    './app/common/auth/handle-auth-error'
  );
  handleAuthError(e);
};

export const index: Promise<void> = (async () => {
  try {
    const config = await getConfiguration<IAppConfig>();
    const options = authClientOptions(config);

    try {
      if (config.environment && config.environment !== 'local') {
        fsInit({ orgId: 'o-1CZ68E-na1' });
      }
    } catch {
      // Do not block loading for a fullstory error
    }

    try {
      const environment = config.environment;
      if (environment && environment !== 'local') {
        datadogRum.init({
          applicationId: 'bc160d93-5b4f-44bd-9453-3e18dd993681',
          clientToken: 'pub1a40b2d850bedeeddbd83c9106359cfe',
          site: 'us3.datadoghq.com',
          service: 'NavisphereOnline.Insight.UI',
          env: environment,
          version: '1.0.0',
          sessionSampleRate: 0,
          sessionReplaySampleRate: 0,
          trackResources: true,
          trackLongTasks: true,
          trackUserInteractions: true,
          defaultPrivacyLevel: 'mask-user-input',
          useSecureSessionCookie: true,
          allowedTracingUrls: [/https:\/\/.*\.chrobinson\.com/],
          beforeSend: (event) => {
            event.view.url = event.view.url.toLowerCase().replace('#/', '');
            return true; // Return true to allow the event to be sent
          },
        });

        datadogRum.startSessionReplayRecording();
      }
    } catch {
      // Do not block loading for a datadog error
    }

    // null if not internal user
    if (options) {
      const { createClient } = await import(
        '@chr/common-web-ui-authentication'
      );

      const authClient = createClient<ChrDecodedJwt>(config, options);

      await bootStrapAppAsync(
        authClient,
        async () => {
          const { bootstrap } = await import('./bootstrap-internal');
          bootstrap(config, authClient);
        },
        authError
      );
    } else {
      const { bootstrap } = await import('./bootstrap-online');
      bootstrap(config);
    }
  } catch (e) {
    // This is an error that can be thrown when ES modules aren't natively supported.
    // There is a pollyfill in place so we just swallow this error.
    // Temporary until we find a better error handling solution
    if (
      e instanceof Error &&
      e.message.indexOf('Error resolving module') > -1
    ) {
      return;
    }
  }
})();
